// @flow

// Types
import type {
  ActionCreator,
  Action,
} from 'fc-flow-types/redux'

// Utils
import createAction from 'fc-utils/createAction'

import {
  // Action Types
  POST_EULA_STATUS,
  ACCEPT_EULA,
  CHECK_EULA_STATUS,
} from './constants'

export function acceptEula (payload: Object): Action<> {
  return {
    type: ACCEPT_EULA,
    payload,
  }
}

export const postEulaStatus: ActionCreator<> = createAction(POST_EULA_STATUS)

export const checkEulaStatus: ActionCreator<> = createAction(CHECK_EULA_STATUS)
